import React, { useEffect, useState, useCallback } from "react";
import { RiCheckboxBlankCircleFill } from "react-icons/ri";
import BaseInput from "../../BaseComponents/BaseInput";
import BaseTimePicker from "../../BaseComponents/BaseTimePicker";
import BaseModal from "../../BaseComponents/BaseModal";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as yup from "yup";
import BaseSelect from "../../BaseComponents/BaseSelect";
import BaseRadioGroup from "../../BaseComponents/BaseRadio";
import BaseDatePicker from "../../BaseComponents/BaseDatePicker";
import {
  attendanceLabel,
  holiday,
  nameLabel,
  paidLeave,
  weekOff,
} from "../../Constant/HR_Attendance/hrAttendance";
import { SelectPlaceHolder, validationMessages } from "../../Constant/validation";
import { All, HOLIDAY_OFF, notFound, Submit, Update, WEEK_OFF } from "../../Constant";
import { PlaceHolderFormat } from "../../Constant/requireMessage";
import {
  addNote,
  addStaffAttendance,
  attendanceMusterRollReport,
  listOfWorkingDay,
  revertStatus,
  revertWeekOffStatus,
  viewAttendance,
  viewLogs,
} from "../../Api/HrAttendance";
import moment from "moment";
import { useSelectedCenter } from "../CenterContext";
import { viewStaffApi } from "../../Api/HRStaffApi";
import { centerApi } from "../../Api/common";
import {
  createOvertimeRequestApi,
  createPreApprovalOvertimeRequestApi,
  approveOvertimeRequestApi,
} from "../../Api/overtimePolicyApi";
import {
  checkStatusCodeSuccess,
  convertToAmPm,
  convertToTimeFormat,
  dateMonthName,
  extractDate,
  extractDateAsM,
  extractDayMonth,
  extractHoursDay,
  extractMonth,
  extractMonthWithName,
  getFormatDayName,
  getItem,
  monthUpdate,
  onErrorImage,
  staffLeaveHistory,
  todayDate,
  getLocalItem,
} from "../../Constant/common";
import { toast } from "react-toastify";
import { staffAttendance } from "../../Constant/title";
import { useParams } from "react-router-dom";
import StaffCard from "../../BaseComponents/StaffCard";
import CountUp from "react-countup";
import CustomPagination from "../../BaseComponents/BasePagination";
import Popovers from "../../CommonElements/Popover";
import { staffAttendanceApi } from "../../Api/reportApi";
import { BaseAttendanceURL } from "../../Api/Service";
import { usePageLoader } from "../../_helper/loading/LoadingContext";
import {
  ChevronLeft,
  ChevronRight,
  Download,
  AlertCircle,
  UserCheck,
  UserX,
  Clock,
  Calendar,
  Umbrella,
  AlertTriangle,
} from "react-feather";

/* ── Stat config ── */
const STAT_CONFIG = {
  [attendanceLabel.Present]: { color: "#10b981", bg: "rgba(16,185,129,0.12)", Icon: UserCheck },
  [attendanceLabel.AbsentLabel]: { color: "#f43f5e", bg: "rgba(244,63,94,0.12)", Icon: UserX },
  [attendanceLabel.HalfDay]: { color: "#f59e0b", bg: "rgba(245,158,11,0.12)", Icon: Clock },
  [attendanceLabel.CompOffLabel]: { color: "#8b5cf6", bg: "rgba(139,92,246,0.12)", Icon: Calendar },
  [attendanceLabel.LeaveStatus]: { color: "#6366f1", bg: "rgba(99,102,241,0.12)", Icon: Umbrella },
  [attendanceLabel.WeekOff]: { color: "#06b6d4", bg: "rgba(6,182,212,0.12)", Icon: Calendar },
  [attendanceLabel.Holiday]: { color: "#f97316", bg: "rgba(249,115,22,0.12)", Icon: Calendar },
  [attendanceLabel.UnpaidLeave]: { color: "#ef4444", bg: "rgba(239,68,68,0.12)", Icon: UserX },
  [attendanceLabel.noteMarked]: { color: "#64748b", bg: "rgba(100,116,139,0.12)", Icon: Clock },
  [attendanceLabel.LessHourStatus]: {
    color: "#ec4899",
    bg: "rgba(236, 72, 153, 0.12)",
    Icon: Clock,
  },
  [attendanceLabel.Error]: {
    color: "#ec4899",
    bg: "rgba(236, 72, 153, 0.12)",
    Icon: AlertTriangle,
  },
};

const AttendanceDetails = () => {
  const { staffId } = useParams();
  const { setLoading } = usePageLoader();
  const { selectedCenter } = useSelectedCenter();

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [profileData, setProfileData] = useState(null);
  const [activePolicy, setActivePolicy] = useState(null);
  const [currentAttendanceId, setCurrentAttendanceId] = useState(null);
  const [currentStaffDate, setCurrentStaffDate] = useState("");
  const [modalType, setModalType] = useState(null);
  const [btnLoader, setBtnLoader] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [noteModal, setNoteModal] = useState(false);
  const [logModal, setLogModal] = useState(false);
  const [attendancedata, setAttendanceData] = useState([]);
  const [logs, setLogs] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState(null);
  const [countData, setCountData] = useState([]);
  const [attendanceId, setAttendanceId] = useState(null);
  const [workData, setWorkData] = useState([]);
  const [leaveData, setLeaveData] = useState([]);
  const [halfLeaveData, setHalfLeaveData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [isSecondModalOpen, setSecondModalOpen] = useState(false);
  const [staffDetail, setStaffDetail] = useState(null);
  const [leaveType, setLeaveType] = useState(null);
  const [halfLeave, setHalfLeave] = useState(null);
  const [reportModal, setReportModal] = useState(false);

  const firstDateOfCurrentMonth = new Date(
    Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1),
  )
    .toISOString()
    .split("T")[0];
  let weekOffStatus = false;
  let holidayOffStatus = false;
  let compOffHistory;

  document.title = staffAttendance;

  /* ── Fetch ── */
  const fetchData = useCallback(
    (date, query) => {
      setLoading(true);
      attendanceMusterRollReport({
        searchDate: extractMonth(date),
        staff_id: parseInt(staffId),
        pageSize,
        pageNumber: currentPage,
        search: query || "",
        order: ["date", "desc"],
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res.statusCode)) {
            setAttendanceData(res?.data?.transformedResponse);
            setCountData(res?.data);
            setTotalPages(res?.data?.totalPages);
          } else {
            setAttendanceData([]);
            toast.error(res?.message);
          }
        })
        .catch(() => {
          setAttendanceData([]);
          setCountData([]);
        })
        .finally(() => setLoading(false));
    },
    [staffId, pageSize, currentPage, setLoading],
  );

  const fetchWorkingDay = useCallback(() => {
    setLoading(true);
    listOfWorkingDay({ condition: { staff_id: staffId } })
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) {
          setWorkData(
            res?.data?.listOfComOffLeave?.map((item) => ({
              value: item?.id,
              label: extractDate(item?.date),
              id: item?.id,
            })),
          );
        } else {
          setWorkData([]);
          toast.error(res?.message);
        }
      })
      .catch(() => setWorkData([]))
      .finally(() => setLoading(false));
  }, [staffId, setLoading]);

  const fetchLeaveCount = useCallback(() => {
    setLoading(true);
    viewAttendance({ searchDate: currentStaffDate, condition: { id: currentAttendanceId } })
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) {
          const leave = res?.data?.listOfStaffDetail[0]?.staffAttendanceHistory[0];
          if (leave?.attendance_status === attendanceLabel.HalfDay) setHalfLeave(leave.leave_type);
          else if (leave?.attendance_status === attendanceLabel.PaidLeaveLabel)
            setLeaveType(leave.leave_type);
        } else toast.error(res?.message);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [currentStaffDate, currentAttendanceId, setLoading]);

  useEffect(() => {
    fetchData(selectedDate, searchQuery);
  }, [selectedDate, searchQuery, currentPage, pageSize, fetchData]);

  useEffect(() => {
    if (staffId) {
      viewStaffApi(staffId)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            setProfileData(res?.data);
          }
        })
        .catch(() => {});
    }
  }, [staffId]);

  useEffect(() => {
    const orgId = getLocalItem("organizationId");
    if (orgId) {
      centerApi({ condition: { organizationId: Number(orgId) } })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            const centerData = resp?.data || [];
            const staffCenterId = profileData?.primary_center_id || selectedCenter;
            const currentCenter = centerData.find((c) => c.id === staffCenterId);
            const policy = currentCenter?.activeOvertimePolicy || null;
            setActivePolicy(policy);
          }
        })
        .catch(() => {});
    }
  }, [profileData, selectedCenter]);

  const parseWorkingHours = (str) => {
    if (!str) return 0;
    if (typeof str === "number") return str;
    const cleaned = str
      .trim()
      .replace(/hours?/gi, "")
      .trim();
    if (cleaned.includes(":")) {
      const parts = cleaned.split(":");
      const h = parseInt(parts[0], 10) || 0;
      const m = parseInt(parts[1], 10) || 0;
      return h + m / 60;
    }
    return parseFloat(cleaned) || 0;
  };

  const getShiftHours = () => {
    const shift =
      staffDetail?.staff?.staffGeneralInformation?.shift ||
      (attendancedata?.[0]?.shift_in_time && attendancedata?.[0]) ||
      attendancedata?.[0]?.shift ||
      profileData?.staffGeneralInformation?.shift;
    if (!shift || !shift.shift_in_time || !shift.shift_out_time) return 0;

    const start = moment(shift.shift_in_time, ["HH:mm:ss", "HH:mm", "hh:mm A"]);
    const end = moment(shift.shift_out_time, ["HH:mm:ss", "HH:mm", "hh:mm A"]);

    if (start.isValid() && end.isValid()) {
      let diff = end.diff(start, "minutes");
      if (diff < 0) {
        diff += 24 * 60;
      }
      return diff / 60;
    }
    return 0;
  };

  const getCalculatedExtraMinutes = () => {
    const totalWorkingHoursStr = staffDetail?.total_working_hours;
    const workedHours = parseWorkingHours(totalWorkingHoursStr);
    const shiftHours = getShiftHours();
    const isAfterShift = activePolicy?.calculation_type === "After Shift Hours";
    const threshold = isAfterShift ? 0 : parseFloat(activePolicy?.minimum_ot_threshold) || 0;

    const extraWorkedBeforeThreshold = Math.max(0, workedHours - shiftHours);
    const extraHours = Math.max(0, extraWorkedBeforeThreshold - threshold);
    return Math.round(extraHours * 60);
  };

  const isOvertimeEligible = (staffRecord, memberData) => {
    // If overtime is already added, they're not eligible for a new request
    if (staffRecord?.overtime_requested_minutes != null) {
      return false;
    }

    const totalWorkingHoursStr = staffRecord?.total_working_hours;
    if (!totalWorkingHoursStr) {
      return false;
    }

    const workedHours = parseWorkingHours(totalWorkingHoursStr);

    const shift =
      staffRecord?.staff?.staffGeneralInformation?.shift ||
      (memberData?.shift_in_time && memberData) ||
      memberData?.shift ||
      (attendancedata?.[0]?.shift_in_time && attendancedata?.[0]) ||
      attendancedata?.[0]?.shift ||
      profileData?.staffGeneralInformation?.shift;

    if (!shift || !shift.shift_in_time || !shift.shift_out_time) {
      return false;
    }

    const start = moment(shift.shift_in_time, ["HH:mm:ss", "HH:mm", "hh:mm A"]);
    const end = moment(shift.shift_out_time, ["HH:mm:ss", "HH:mm", "hh:mm A"]);
    if (!start.isValid() || !end.isValid()) {
      return false;
    }

    let shiftMinutes = end.diff(start, "minutes");
    if (shiftMinutes < 0) shiftMinutes += 24 * 60;
    const shiftHours = shiftMinutes / 60;

    const isAfterShift = activePolicy?.calculation_type === "After Shift Hours";
    const threshold = isAfterShift ? 0 : parseFloat(activePolicy?.minimum_ot_threshold) || 0.5;

    const extraWorkedBeforeThreshold = Math.max(0, workedHours - shiftHours);
    const extraHours = Math.max(0, extraWorkedBeforeThreshold - threshold);
    const extraMinutes = Math.round(extraHours * 60);

    return extraMinutes > 0;
  };

  const handleOvertimeSubmit = (values) => {
    setBtnLoader(true);
    const isPost = values.otRequestType === "Post Overtime Required";
    const convertTimeToMinutes = (timeValue) => {
      if (!timeValue) return 0;
      const [hours, minutes] = timeValue.split(":").map(Number);
      return (Number.isFinite(hours) ? hours : 0) * 60 + (Number.isFinite(minutes) ? minutes : 0);
    };
    const requestedMinutes = convertTimeToMinutes(values.requested_time);

    const payload = isPost
      ? {
          staff_id: parseInt(staffId),
          policy_id: Number(values.policy_id),
          request_date: staffDetail?.date,
          reason: values.otReason,
          project_task: values.project_task,
        }
      : {
          staff_id: parseInt(staffId),
          request_date: staffDetail?.date,
          requested_minutes: requestedMinutes,
          reason: values.otReason,
          project_task: values.project_task,
        };

    const apiCall = isPost ? createOvertimeRequestApi : createPreApprovalOvertimeRequestApi;

    apiCall(payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          const requestId = resp?.data?.id || resp?.data || resp?.id;
          if (requestId) {
            const calculatedMinutes = getCalculatedExtraMinutes();
            const minutesToApprove = isPost
              ? calculatedMinutes > 0
                ? calculatedMinutes
                : 90
              : requestedMinutes;
            approveOvertimeRequestApi(requestId, {
              status: "Approved",
              approved_minutes: minutesToApprove,
              manager_comments: "Approved for critical project work",
              rejection_reason: "Request exceeds weekly OT limit",
            })
              .then((approveResp) => {
                if (checkStatusCodeSuccess(approveResp?.statusCode)) {
                  toast.success("Overtime request created and approved successfully!");
                } else {
                  toast.warning(
                    `Request created but auto-approval failed: ${approveResp?.message}`,
                  );
                }
                fetchData(selectedDate);
              })
              .catch((err) => {
                toast.error(`Auto-approval error: ${err?.response?.data?.message || err?.message}`);
                fetchData(selectedDate);
              });
          } else {
            toast.success(resp?.message || "Overtime request submitted successfully.");
            fetchData(selectedDate);
          }
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message || err?.message))
      .finally(() => {
        setBtnLoader(false);
        resetForm();
        setModalType(null);
        setCurrentAttendanceId(null);
      });
  };

  useEffect(() => {
    fetchData(selectedDate, searchQuery);
  }, [selectedDate, searchQuery, currentPage, pageSize, fetchData]);
  useEffect(() => {
    if (
      (modalType === attendanceLabel.paidLeaveModal ||
        modalType === attendanceLabel.halfDayModal) &&
      selectedDate &&
      currentAttendanceId
    )
      fetchLeaveCount();
  }, [selectedDate, modalType, currentAttendanceId, fetchLeaveCount]);
  useEffect(() => {
    if (modalType === attendanceLabel.compOffModal) fetchWorkingDay();
  }, [modalType, currentAttendanceId, fetchWorkingDay]);

  /* ── Date nav ── */
  const incrementDate = () => {
    const d = monthUpdate(selectedDate, attendanceLabel.add);
    setSelectedDate(d);
    fetchData(d);
  };
  const decrementDate = () => {
    const d = monthUpdate(selectedDate, attendanceLabel.subtract);
    setSelectedDate(d);
    fetchData(d);
  };

  /* ── Revert ── */
  const RevertStatusToHoliday = (id) => {
    setLoading(true);
    revertStatus(id)
      .then((res) => {
        checkStatusCodeSuccess(res.statusCode)
          ? toast.success(res?.message)
          : toast.error(res?.message);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        fetchData(selectedDate);
      });
  };
  const RevertStatusToWeekOff = (id) => {
    setLoading(true);
    revertWeekOffStatus(id)
      .then((res) => {
        checkStatusCodeSuccess(res.statusCode)
          ? toast.success(res?.message)
          : toast.error(res?.message);
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
        fetchData(selectedDate);
      });
  };

  /* ── Logs ── */
  const handleViewLogs = (data) => {
    setLoading(true);
    setLogModal(true);
    viewLogs(data?.staff_attendance_id)
      .then((res) => {
        if (checkStatusCodeSuccess(res.statusCode)) setLogs(res?.data);
        else {
          setLogs([]);
          toast.error(res?.message);
        }
      })
      .catch(() => setLogs([]))
      .finally(() => setLoading(false));
  };

  const togglePopover = (id) => {
    setPopoverOpen(popoverOpen === id ? null : id);
  };

  /* ── Pagination ── */
  const handlePageChange = (p) => setCurrentPage(p);
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };
  const handlePageSizeChange = (e) => {
    setPageSize(e.target.value === All ? null : Number(e.target.value));
    setCurrentPage(1);
  };

  /* ── Note ── */
  const handleNoteModal = (id, currentNote) => {
    setAttendanceId(id);
    formikNote.setFieldValue(nameLabel.note, currentNote ?? "");
    setNoteModal(true);
  };

  /* ── Formik ── */
  const getFormikConfig = (type) => {
    const isTimeModal =
      type === attendanceLabel.presentModal ||
      type === attendanceLabel.halfDayModal ||
      type === attendanceLabel.LessHourStatus;
    const inTimePrefill = isTimeModal ? convertToTimeFormat(staffDetail?.in_time) || null : null;
    const outTimePrefill = isTimeModal ? convertToTimeFormat(staffDetail?.out_time) || null : null;
    const commonValidation = {
      inTime: Yup.string().required(validationMessages.required(attendanceLabel.InTime)),
      outTime: Yup.string()
        .nullable()
        .test(
          attendanceLabel.IsGreater,
          validationMessages.greaterThan(attendanceLabel.InTime, attendanceLabel.OutTime),
          function (v) {
            return v ? (this.parent.inTime ? v >= this.parent.inTime : true) : true;
          },
        ),
    };
    const leaveSchema = Yup.object({
      leaveOption: Yup.string().required(validationMessages.required(attendanceLabel.LeaveOption)),
    });
    switch (type) {
      case attendanceLabel.LessHourStatus:
        return {
          enableReinitialize: true,
          initialValues: { inTime: inTimePrefill, outTime: outTimePrefill },
          validationSchema: Yup.object({
            inTime: Yup.string().required(validationMessages.required(attendanceLabel.InTime)),
            outTime: Yup.string()
              .required(validationMessages.required(attendanceLabel.OutTime))
              .test(
                attendanceLabel.IsGreater,
                validationMessages.greaterThan(attendanceLabel.InTime, attendanceLabel.OutTime),
                function (v) {
                  return v && this.parent.inTime ? v >= this.parent.inTime : true;
                },
              ),
          }),
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.presentModal:
        return {
          enableReinitialize: true,
          initialValues: { inTime: inTimePrefill, outTime: outTimePrefill },
          validationSchema: Yup.object(commonValidation),
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.halfDayModal:
        return {
          enableReinitialize: true,
          initialValues: { inTime: inTimePrefill, outTime: outTimePrefill, leaveOption: halfLeave },
          validationSchema: isSecondModalOpen ? leaveSchema : Yup.object(commonValidation),
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.paidLeaveModal:
        return {
          enableReinitialize: true,
          initialValues: { leaveOption: leaveType },
          validationSchema: Yup.object({
            leaveOption: Yup.string().required(
              validationMessages.required(attendanceLabel.LeaveOption),
            ),
          }),
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.compOffModal:
        return {
          enableReinitialize: true,
          initialValues: { workedHoliday: "", compensationDay: staffDetail?.date },
          validationSchema: Yup.object({
            workedHoliday: Yup.string().required(
              validationMessages.required(attendanceLabel.WorkedHoliday),
            ),
            compensationDay: Yup.string().required(
              validationMessages.required(attendanceLabel.CompensationDay),
            ),
          }),
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.absentModal:
        return {
          enableReinitialize: true,
          initialValues: { reason: staffDetail?.remarks || "" },
          onSubmit: (v) => handleFormSubmit(addStaffAttendance, v, type),
        };
      case attendanceLabel.overtimeModal:
        return {
          enableReinitialize: true,
          initialValues: {
            policy_id: activePolicy?.id ? String(activePolicy.id) : "",
            project_task: "",
            otReason: "",
            requested_time: "",
            otRequestType: activePolicy?.approval_type || "Post Overtime Required",
          },
          validationSchema: Yup.object({
            project_task: Yup.string().required(validationMessages.required("Project / Task")),
            otReason: Yup.string().required(validationMessages.required("Reason")),
            policy_id: Yup.string().when("otRequestType", {
              is: "Post Overtime Required",
              then: (schema) => schema.required(validationMessages.required("Overtime Policy")),
              otherwise: (schema) => schema.optional().nullable(),
            }),
            requested_time: Yup.string().when("otRequestType", {
              is: "Pre Overtime Required",
              then: (schema) =>
                schema
                  .required(validationMessages.required("Requested Time"))
                  .test("valid-time", "Please select a valid time", (value) => {
                    if (!value) return false;
                    const parts = value.split(":");
                    if (parts.length < 2) return false;
                    const hours = parseInt(parts[0], 10);
                    const minutes = parseInt(parts[1], 10);
                    return hours > 0 || minutes > 0;
                  }),
              otherwise: (schema) => schema.optional().nullable(),
            }),
          }),
          onSubmit: (values) => handleOvertimeSubmit(values),
        };
      default:
        return {};
    }
  };

  const formikNote = useFormik({
    initialValues: { note: "" },
    validationSchema: Yup.object({
      note: Yup.string().required(validationMessages.required(attendanceLabel.note)),
    }),
    onSubmit: (values) => {
      setBtnLoader(true);
      addNote(attendanceId, { attendance_note: values.note })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            toast.success(resp?.message);
            fetchData(selectedDate);
          } else toast.error(resp?.message);
        })
        .catch((err) => toast.error(err?.response?.data?.message || err?.message))
        .finally(() => {
          setNoteModal(false);
          resetForm();
          setAttendanceId(null);
          setBtnLoader(false);
        });
    },
  });
  const formikPresent = useFormik(getFormikConfig(attendanceLabel.presentModal));
  const formikHalfDay = useFormik(getFormikConfig(attendanceLabel.halfDayModal));
  const formikPaidLeave = useFormik(getFormikConfig(attendanceLabel.paidLeaveModal));
  const formikCompOff = useFormik(getFormikConfig(attendanceLabel.compOffModal));
  const formikAbsent = useFormik(getFormikConfig(attendanceLabel.absentModal));
  const formikOvertime = useFormik(getFormikConfig(attendanceLabel.overtimeModal));
  const formikLessHour = useFormik(getFormikConfig(attendanceLabel.LessHourStatus));

  const handleFormSubmit = (apiCall, values, type) => {
    setBtnLoader(true);
    let payload;
    switch (type) {
      case attendanceLabel.LessHourStatus:
        payload = {
          attendance_status: attendanceLabel.LessHourStatus,
          in_time: convertToAmPm(values.inTime),
          out_time: values.outTime && convertToAmPm(values.outTime),
        };
        break;
      case attendanceLabel.presentModal:
        payload = {
          attendance_status: attendanceLabel.PresentStatus,
          in_time: convertToAmPm(values.inTime),
          out_time: values.outTime && convertToAmPm(values.outTime),
        };
        break;
      case attendanceLabel.halfDayModal:
        payload = {
          attendance_status: attendanceLabel.HalfDay,
          in_time: convertToAmPm(values.inTime),
          out_time: values.outTime && convertToAmPm(values.outTime),
          leave_type: values.leaveOption,
        };
        break;
      case attendanceLabel.paidLeaveModal:
        payload = {
          attendance_status: attendanceLabel.PaidLeaveStatus,
          leave_type: values.leaveOption,
        };
        break;
      case attendanceLabel.compOffModal:
        payload = {
          attendance_status: attendanceLabel.CompOffStatus,
          comp_off_leave_history_id: values.workedHoliday,
          composition_day_date: values.compensationDay,
        };
        break;
      case attendanceLabel.absentModal:
        payload = { attendance_status: attendanceLabel.AbsentStatus, remarks: values.reason };
        break;
      default:
        payload = {};
    }
    apiCall(currentAttendanceId, payload)
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
          fetchData(selectedDate);
        } else toast.error(resp?.message);
      })
      .catch((err) => toast.error(err?.response?.data?.message || err?.message))
      .finally(() => {
        setBtnLoader(false);
        resetForm();
        setModalType(null);
        setCurrentAttendanceId(null);
        setSecondModalOpen(false);
      });
  };

  const resetForm = () => {
    formikPresent.resetForm();
    formikHalfDay.resetForm();
    formikPaidLeave.resetForm();
    formikNote.resetForm();
    formikCompOff.resetForm();
    formikAbsent.resetForm();
    formikOvertime.resetForm();
    formikLessHour.resetForm();
  };
  const closeModal = () => {
    setModalType(null);
    formikPaidLeave.setFieldValue(nameLabel.leaveOption, "");
    resetForm();
    setStaffDetail(null);
    setActivePolicy(null);
  };
  const handleHalfDaySubmit = () => {
    formikHalfDay.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) setSecondModalOpen(true);
    });
  };

  const openModal = (type, staff) => {
    setCurrentAttendanceId(staff?.staff_attendance_id);
    setModalType(type);
    setStaffDetail(staff);
    setCurrentStaffDate(staff?.date);
    if (type === attendanceLabel.halfDayModal || type === attendanceLabel.paidLeaveModal)
      staffLeaveHistory(parseInt(staffId), setHalfLeaveData, setLeaveData, () => {});

    if (type === attendanceLabel.overtimeModal) {
      const orgId = getLocalItem("organizationId");
      centerApi({ condition: { organizationId: Number(orgId) } })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            const centerData = resp?.data || [];
            const staffCenterId =
              staff?.staff?.primary_center_id || profileData?.primary_center_id || selectedCenter;
            const currentCenter = centerData.find((c) => c.id === staffCenterId);
            const policy = currentCenter?.activeOvertimePolicy || null;
            setActivePolicy(policy);

            if (policy?.approval_type === "Post Overtime Required" && policy.id) {
              formikOvertime.setFieldValue("policy_id", String(policy.id));
            }
          } else {
            setActivePolicy(null);
          }
        })
        .catch(() => setActivePolicy(null));
    }
  };

  const shift_name = attendancedata?.[0]?.shift_name;
  const in_time = extractHoursDay(attendancedata?.[0]?.shift_in_time);
  const out_time = extractHoursDay(attendancedata?.[0]?.shift_out_time);

  const ShiftInfo = () =>
    shift_name ? (
      <div
        style={{
          padding: "8px 12px",
          marginBottom: 12,
          borderRadius: 8,
          background: "rgba(99,102,241,0.06)",
          border: "1px solid rgba(99,102,241,0.15)",
          fontSize: "0.8125rem",
          color: "var(--brand-indigo)",
          fontWeight: 600,
        }}
      >
        {shift_name}
        {in_time && out_time && (
          <span style={{ fontWeight: 400, color: "var(--text-muted)" }}>
            {" "}
            · {in_time} – {out_time}
          </span>
        )}
      </div>
    ) : null;

  const renderModalContent = () => {
    switch (modalType) {
      case attendanceLabel.LessHourStatus:
        return (
          <>
            <ShiftInfo />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <BaseTimePicker
                name={nameLabel.inTime}
                label={attendanceLabel.InTime}
                value={formikLessHour.values.inTime}
                onChange={(val) => formikLessHour.setFieldValue(nameLabel.inTime, val)}
                touched={formikLessHour.touched.inTime}
                error={formikLessHour.errors.inTime}
                onBlur={() => formikLessHour.setFieldTouched(nameLabel.inTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
                required
              />
              <BaseTimePicker
                name={nameLabel.outTime}
                label={attendanceLabel.OutTime}
                value={formikLessHour.values.outTime}
                onChange={(val) => formikLessHour.setFieldValue(nameLabel.outTime, val)}
                touched={formikLessHour.touched.outTime}
                error={formikLessHour.errors.outTime}
                onBlur={() => formikLessHour.setFieldTouched(nameLabel.outTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
                required
              />
            </div>
          </>
        );
      case attendanceLabel.presentModal:
        return (
          <>
            <ShiftInfo />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <BaseTimePicker
                name={nameLabel.inTime}
                label={attendanceLabel.InTime}
                value={formikPresent.values.inTime}
                onChange={(val) => formikPresent.setFieldValue(nameLabel.inTime, val)}
                touched={formikPresent.touched.inTime}
                error={formikPresent.errors.inTime}
                onBlur={() => formikPresent.setFieldTouched(nameLabel.inTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
                required
              />
              <BaseTimePicker
                name={nameLabel.outTime}
                label={attendanceLabel.OutTime}
                value={formikPresent.values.outTime}
                onChange={(val) => formikPresent.setFieldValue(nameLabel.outTime, val)}
                touched={formikPresent.touched.outTime}
                error={formikPresent.errors.outTime}
                onBlur={() => formikPresent.setFieldTouched(nameLabel.outTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
              />
            </div>
          </>
        );
      case attendanceLabel.halfDayModal:
        return (
          <>
            <ShiftInfo />
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <BaseTimePicker
                name={nameLabel.inTime}
                label={attendanceLabel.InTime}
                value={formikHalfDay.values.inTime}
                onChange={(val) => formikHalfDay.setFieldValue(nameLabel.inTime, val)}
                touched={formikHalfDay.touched.inTime}
                error={formikHalfDay.errors.inTime}
                onBlur={() => formikHalfDay.setFieldTouched(nameLabel.inTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
                required
              />
              <BaseTimePicker
                name={nameLabel.outTime}
                label={attendanceLabel.OutTime}
                value={formikHalfDay.values.outTime}
                onChange={(val) => formikHalfDay.setFieldValue(nameLabel.outTime, val)}
                touched={formikHalfDay.touched.outTime}
                error={formikHalfDay.errors.outTime}
                onBlur={() => formikHalfDay.setFieldTouched(nameLabel.outTime, true)}
                placeholder={attendanceLabel.selectTime}
                timeIntervals={1}
              />
            </div>
          </>
        );
      case attendanceLabel.paidLeaveModal:
        return halfLeaveData?.length > 0 ? (
          <>
            <ShiftInfo />
            <BaseRadioGroup
              name="leaveOption"
              options={halfLeaveData}
              selectedValue={formikPaidLeave.values.leaveOption}
              onChange={(e) => formikPaidLeave.setFieldValue(nameLabel.leaveOption, e.target.value)}
              value={formikPaidLeave.values.leaveOption}
              touched={formikPaidLeave.touched.leaveOption}
              error={formikPaidLeave.errors.leaveOption}
              handleBlur={formikPaidLeave.handleBlur}
            />
          </>
        ) : (
          <p style={{ textAlign: "center", color: "var(--text-muted)", padding: "20px 0" }}>
            {attendanceLabel.noLeaveAvailable}
          </p>
        );
      case attendanceLabel.compOffModal:
        return (
          <>
            <ShiftInfo />
            <BaseSelect
              label={attendanceLabel.WorkedHoliday}
              name={nameLabel.workedHoliday}
              options={workData}
              placeholder={SelectPlaceHolder(attendanceLabel.WorkedHoliday)}
              handleChange={(field, value) => formikCompOff.setFieldValue(field, value)}
              value={formikCompOff.values.workedHoliday}
              touched={formikCompOff.touched.workedHoliday}
              error={formikCompOff.errors.workedHoliday}
              handleBlur={formikCompOff.handleBlur}
              required
            />
            <BaseDatePicker
              label={attendanceLabel.CompensationDay}
              name={nameLabel.compensationDay}
              onChange={(v) => formikCompOff.setFieldValue(nameLabel.compensationDay, v)}
              value={formikCompOff.values.compensationDay}
              touched={formikCompOff.touched.compensationDay}
              error={formikCompOff.errors.compensationDay}
              onBlur={formikCompOff.handleBlur}
              disabled
              required
            />
          </>
        );
      case attendanceLabel.absentModal:
        return (
          <>
            <ShiftInfo />
            <BaseInput
              type="textarea"
              name={nameLabel.reason}
              label={attendanceLabel.Remarks}
              placeholder={PlaceHolderFormat(attendanceLabel.reasonForAbsent)}
              handleChange={formikAbsent.handleChange}
              value={formikAbsent.values.reason}
              touched={formikAbsent.touched.reason}
              error={formikAbsent.errors.error}
              handleBlur={formikAbsent.handleBlur}
            />
          </>
        );
      case attendanceLabel.overtimeModal: {
        // Check if overtime has been added (either via overtimeRequests array or direct overtime fields)
        const hasOvertimeRequest =
          staffDetail?.overtime_requested_minutes != null ||
          (staffDetail?.overtimeRequests && staffDetail.overtimeRequests.length > 0);

        if (hasOvertimeRequest) {
          // Use overtime data from either the direct fields or the requests array
          const req =
            staffDetail?.overtime_requested_minutes != null
              ? {
                  status: staffDetail?.overtime_status || "Pending",
                  requested_minutes: staffDetail?.overtime_requested_minutes,
                  approved_minutes: staffDetail?.overtime_approved_minutes,
                  eligible_minutes: staffDetail?.overtime_eligible_minutes,
                  payable_minutes: staffDetail?.overtime_payable_minutes,
                  reason: staffDetail?.overtime_reason,
                  manager_comments: staffDetail?.overtime_manager_comments,
                  rejection_reason: staffDetail?.overtime_rejection_reason,
                  approved_at: staffDetail?.overtime_approved_at,
                  approved_by: staffDetail?.overtime_approved_by,
                  project_task: staffDetail?.overtime_project_task,
                  request_type: staffDetail?.overtime_request_type,
                  calculation_type: staffDetail?.overtime_calculation_type,
                }
              : staffDetail?.overtimeRequests?.[0];

          const statusColors = {
            Approved: {
              text: "#10b981",
              bg: "rgba(16,185,129,0.06)",
              border: "rgba(16,185,129,0.15)",
            },
            Rejected: {
              text: "#f43f5e",
              bg: "rgba(244,63,94,0.06)",
              border: "rgba(244,63,94,0.15)",
            },
            Pending: {
              text: "#f59e0b",
              bg: "rgba(245,158,11,0.06)",
              border: "rgba(245,158,11,0.15)",
            },
          };
          const colors = statusColors[req.status] || statusColors.Pending;

          const formatMinutes = (minutes) => {
            const mins = parseFloat(minutes) || 0;
            const hours = Math.floor(mins / 60);
            const remainingMins = Math.round(mins % 60);
            if (hours === 0 && remainingMins === 0) return "0 hours";
            return `${hours > 0 ? `${hours}h ` : ""}${remainingMins > 0 ? `${remainingMins}m` : ""}`.trim();
          };

          return (
            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              <ShiftInfo />

              {/* Premium Status Header */}
              <div
                style={{
                  padding: "16px",
                  borderRadius: 12,
                  background: colors.bg,
                  border: `1px solid ${colors.border}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span
                    style={{
                      fontSize: "0.6875rem",
                      fontWeight: 700,
                      color: "var(--text-muted)",
                      textTransform: "uppercase",
                      letterSpacing: "0.05em",
                    }}
                  >
                    Overtime Request Status
                  </span>
                  <h4
                    style={{
                      margin: "4px 0 0",
                      fontSize: "1.25rem",
                      fontWeight: 800,
                      color: colors.text,
                    }}
                  >
                    {req.status}
                  </h4>
                </div>
                {req.approved_at && (
                  <div style={{ textAlign: "right" }}>
                    <span
                      style={{ fontSize: "0.625rem", color: "var(--text-muted)", display: "block" }}
                    >
                      Approved Date
                    </span>
                    <span
                      style={{ fontSize: "0.75rem", fontWeight: 700, color: "var(--text-primary)" }}
                    >
                      {moment(req.approved_at).format("MMM DD, YYYY")}
                    </span>
                  </div>
                )}
                {req.rejection_date && (
                  <div style={{ textAlign: "right" }}>
                    <span
                      style={{ fontSize: "0.625rem", color: "var(--text-muted)", display: "block" }}
                    >
                      Rejected Date
                    </span>
                    <span
                      style={{ fontSize: "0.75rem", fontWeight: 700, color: "var(--text-primary)" }}
                    >
                      {moment(req.rejection_date).format("MMM DD, YYYY")}
                    </span>
                  </div>
                )}
              </div>

              {/* Request Details Grid */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: 12,
                  padding: "16px",
                  borderRadius: 12,
                  background: "var(--glass-bg)",
                  border: "1px solid var(--glass-border)",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                    Requested Duration
                  </span>
                  <span
                    style={{ fontSize: "0.9375rem", fontWeight: 700, color: "var(--text-primary)" }}
                  >
                    {formatMinutes(req.requested_minutes)}
                  </span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                    Approved Duration
                  </span>
                  <span
                    style={{ fontSize: "0.9375rem", fontWeight: 700, color: "var(--brand-indigo)" }}
                  >
                    {formatMinutes(req.approved_minutes)}
                  </span>
                </div>

                <div
                  style={{
                    gridColumn: "1 / -1",
                    height: 1,
                    background: "rgba(0,0,0,0.06)",
                    margin: "4px 0",
                  }}
                />

                <div
                  style={{ gridColumn: "1 / -1", display: "flex", flexDirection: "column", gap: 2 }}
                >
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                    Project / Task
                  </span>
                  <span
                    style={{ fontSize: "0.875rem", fontWeight: 600, color: "var(--text-primary)" }}
                  >
                    {req.project_task || "—"}
                  </span>
                </div>

                <div
                  style={{ gridColumn: "1 / -1", display: "flex", flexDirection: "column", gap: 2 }}
                >
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>Reason</span>
                  <span
                    style={{ fontSize: "0.875rem", fontWeight: 500, color: "var(--text-primary)" }}
                  >
                    {req.reason || "—"}
                  </span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                    Request Type
                  </span>
                  <span
                    style={{ fontSize: "0.875rem", fontWeight: 600, color: "var(--text-primary)" }}
                  >
                    {req.request_type || "—"}
                  </span>
                </div>

                <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                    Calculation Type
                  </span>
                  <span
                    style={{ fontSize: "0.875rem", fontWeight: 600, color: "var(--text-primary)" }}
                  >
                    {req.calculation_type || "—"}
                  </span>
                </div>

                {(req.manager_comments || req.rejection_reason) && (
                  <>
                    <div
                      style={{
                        gridColumn: "1 / -1",
                        height: 1,
                        background: "rgba(0,0,0,0.06)",
                        margin: "4px 0",
                      }}
                    />
                    <div
                      style={{
                        gridColumn: "1 / -1",
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                      }}
                    >
                      <span style={{ fontSize: "0.6875rem", color: "var(--text-muted)" }}>
                        Manager Comments
                      </span>
                      <span
                        style={{
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          color: req.status === "Rejected" ? "#f43f5e" : "var(--text-primary)",
                        }}
                      >
                        {req.status === "Rejected" ? req.rejection_reason : req.manager_comments}
                      </span>
                    </div>
                  </>
                )}
              </div>
            </div>
          );
        }

        return (
          <>
            <ShiftInfo />

            {activePolicy && (
              <div
                style={{
                  padding: "10px 14px",
                  borderRadius: 10,
                  background: "rgba(249,115,22,0.06)",
                  border: "1px solid rgba(249,115,22,0.15)",
                  marginBottom: 16,
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                >
                  <span style={{ fontSize: "0.875rem", fontWeight: 700, color: "#f97316" }}>
                    Active Policy: {activePolicy.policy_name}
                  </span>
                  <span
                    style={{
                      fontSize: "0.75rem",
                      fontWeight: 600,
                      padding: "2px 8px",
                      borderRadius: 12,
                      background: "rgba(249,115,22,0.12)",
                      color: "#f97316",
                    }}
                  >
                    {activePolicy.approval_type}
                  </span>
                </div>
                {activePolicy.description && (
                  <span style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>
                    {activePolicy.description}
                  </span>
                )}
              </div>
            )}

            {(() => {
              const totalWorkingHoursStr = staffDetail?.total_working_hours;

              if (!totalWorkingHoursStr) {
                return (
                  <div
                    style={{
                      padding: "12px 14px",
                      borderRadius: 10,
                      background: "rgba(244,63,94,0.06)",
                      border: "1px solid rgba(244,63,94,0.15)",
                      marginBottom: 16,
                      fontSize: "0.8125rem",
                      color: "#f43f5e",
                      fontWeight: 600,
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <AlertCircle size={16} />
                    <span>No total worked hours recorded for today yet.</span>
                  </div>
                );
              }

              const workedHours = parseWorkingHours(totalWorkingHoursStr);
              const shiftHours = getShiftHours();
              const isAfterShift = activePolicy?.calculation_type === "After Shift Hours";
              const threshold = isAfterShift
                ? 0
                : parseFloat(activePolicy?.minimum_ot_threshold) || 0;

              const extraWorkedBeforeThreshold = Math.max(0, workedHours - shiftHours);
              const extraHours = Math.max(0, extraWorkedBeforeThreshold - threshold);

              const formatDecimalToHoursMinutes = (decimalHours) => {
                const hours = Math.floor(decimalHours);
                const minutes = Math.round((decimalHours - hours) * 60);
                if (hours === 0 && minutes === 0) return "0 hours";
                return `${hours > 0 ? `${hours}h ` : ""}${minutes > 0 ? `${minutes}m` : ""}`.trim();
              };

              return (
                <div
                  style={{
                    padding: "16px",
                    borderRadius: 12,
                    background:
                      "linear-gradient(135deg, rgba(99,102,241,0.06), rgba(139,92,246,0.06))",
                    border: "1px solid rgba(99,102,241,0.15)",
                    marginBottom: 16,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.02)",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: 12,
                    }}
                  >
                    <span
                      style={{
                        fontSize: "0.875rem",
                        fontWeight: 700,
                        color: "var(--brand-indigo)",
                      }}
                    >
                      Overtime Calculation Detail
                    </span>
                    <span
                      style={{
                        fontSize: "0.8125rem",
                        fontWeight: 800,
                        color: "var(--brand-indigo)",
                        background: "rgba(99,102,241,0.12)",
                        padding: "4px 10px",
                        borderRadius: 20,
                      }}
                    >
                      {formatDecimalToHoursMinutes(extraHours)} Extra
                    </span>
                  </div>

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: isAfterShift ? "1fr 1fr 1fr" : "1fr 1fr",
                      gap: 12,
                      fontSize: "0.75rem",
                      color: "var(--text-muted)",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderRight: "1px solid rgba(0,0,0,0.06)",
                        paddingRight: 10,
                      }}
                    >
                      <span>Total Worked:</span>
                      <strong style={{ color: "var(--text-primary)" }}>
                        {formatDecimalToHoursMinutes(workedHours)}
                      </strong>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        borderRight: isAfterShift ? "1px solid rgba(0,0,0,0.06)" : "none",
                        paddingRight: isAfterShift ? 10 : 0,
                      }}
                    >
                      <span>Shift Hours:</span>
                      <strong style={{ color: "var(--text-primary)" }}>
                        {shiftHours > 0 ? formatDecimalToHoursMinutes(shiftHours) : "-"}
                      </strong>
                    </div>
                    {!isAfterShift && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          borderRight: "1px solid rgba(0,0,0,0.06)",
                          paddingRight: 10,
                        }}
                      >
                        <span>Threshold:</span>
                        <strong style={{ color: "var(--text-primary)" }}>
                          {threshold > 0 ? formatDecimalToHoursMinutes(threshold) : "-"}
                        </strong>
                      </div>
                    )}
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <span>Calculated OT:</span>
                      <strong style={{ color: "var(--brand-indigo)", fontWeight: 700 }}>
                        {formatDecimalToHoursMinutes(extraHours)}
                      </strong>
                    </div>
                  </div>
                </div>
              );
            })()}

            {formikOvertime.values.otRequestType === "Pre Overtime Required" && (
              <div style={{ marginBottom: 12 }}>
                <BaseTimePicker
                  name="requested_time"
                  label="Requested Time"
                  placeholder="Select duration"
                  value={formikOvertime.values.requested_time}
                  onChange={(value) => formikOvertime.setFieldValue("requested_time", value)}
                  onBlur={formikOvertime.handleBlur}
                  touched={formikOvertime.touched.requested_time}
                  error={formikOvertime.errors.requested_time}
                  required
                  timeIntervals={15}
                  isDuration
                />
              </div>
            )}

            <div style={{ marginBottom: 12 }}>
              <BaseInput
                type="text"
                name="project_task"
                label="Project / Task"
                placeholder="e.g. Production Deployment - May 2024"
                handleChange={formikOvertime.handleChange}
                handleBlur={formikOvertime.handleBlur}
                value={formikOvertime.values.project_task}
                touched={formikOvertime.touched.project_task}
                error={formikOvertime.errors.project_task}
                required
              />
            </div>

            <div>
              <BaseInput
                name="otReason"
                label={attendanceLabel.OvertimeReason}
                type="text"
                placeholder="Describe the work done during overtime..."
                handleChange={formikOvertime.handleChange}
                value={formikOvertime.values.otReason}
                handleBlur={formikOvertime.handleBlur}
                touched={formikOvertime.touched.otReason}
                error={formikOvertime.errors.otReason}
                required
              />
            </div>
          </>
        );
      }
      default:
        return null;
    }
  };

  const attendanceItems = [
    {
      label: attendanceLabel.Present,
      value: countData?.transformedResponse?.[0]?.statusCount?.present,
    },
    {
      label: attendanceLabel.AbsentLabel,
      value: countData?.transformedResponse?.[0]?.statusCount?.absent,
    },
    {
      label: attendanceLabel.HalfDay,
      value: countData?.transformedResponse?.[0]?.statusCount?.halfDay,
    },
    {
      label: attendanceLabel.CompOffLabel,
      value: countData?.transformedResponse?.[0]?.statusCount?.compOff,
    },
    {
      label: attendanceLabel.LeaveStatus,
      value: countData?.transformedResponse?.[0]?.statusCount?.paidLeave,
    },
    {
      label: attendanceLabel.WeekOff,
      value: countData?.transformedResponse?.[0]?.statusCount?.weekOff,
    },
    {
      label: attendanceLabel.Holiday,
      value: countData?.transformedResponse?.[0]?.statusCount?.holiday,
    },
    {
      label: attendanceLabel.UnpaidLeave,
      value: countData?.transformedResponse?.[0]?.statusCount?.unpaidLeave,
    },
    {
      label: attendanceLabel.noteMarked,
      value: countData?.transformedResponse?.[0]?.statusCount?.unmarked,
    },
    {
      label: attendanceLabel.LessHourStatus,
      value: countData?.transformedResponse?.[0]?.statusCount?.lessHour,
    },
    {
      label: attendanceLabel.Error,
      value: countData?.transformedResponse?.[0]?.statusCount?.error,
    },
  ];

  /* ── Report formik ── */
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { startDate: firstDateOfCurrentMonth, endDate: todayDate },
    validationSchema: yup.object({
      startDate: yup.string().required(validationMessages.required(attendanceLabel.StartDate)),
      endDate: yup
        .string()
        .required(validationMessages.required(attendanceLabel.EndDate))
        .when("startDate", (startDate, schema) =>
          schema.test({
            name: "endDate",
            exclusive: false,
            message: attendanceLabel.endDateValidation,
            test: function (value) {
              if (!value || !startDate) return true;
              const s = new Date(startDate);
              const e = new Date(value);
              return s.getFullYear() === e.getFullYear() && s.getMonth() === e.getMonth() && e > s;
            },
          }),
        ),
    }),
    onSubmit: async (values) => {
      setBtnLoader(true);
      await staffAttendanceApi({
        staff_id: Number(staffId),
        startDate: values.startDate,
        endDate: values.endDate,
      })
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            const blob = new Blob([resp?.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${JSON.parse(getItem("staffData"))?.name}${attendanceLabel.StaffAttendanceReport}`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            toast.success(resp?.success);
          } else toast.error(resp?.message);
        })
        .catch((err) => toast.error(err.response?.data?.message || err.message))
        .finally(() => {
          setBtnLoader(false);
          formik.resetForm();
          setReportModal(false);
        });
    },
  });

  /* ── JSX ── */
  return (
    <div className="animate-fade-in" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {/* ── Month navigator + stats ── */}
      <div
        className="animate-slide-up"
        style={{
          background: "var(--glass-bg)",
          border: "1px solid var(--glass-border)",
          borderRadius: 20,
        }}
      >
        <div
          style={{
            height: 3,
            background: "linear-gradient(90deg,#6366f1,#8b5cf6,#06b6d4)",
            borderRadius: "20px 20px 0 0",
          }}
        />

        {/* Month nav row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "14px 20px 12px",
            borderBottom: "1px solid var(--glass-border)",
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={decrementDate}
              aria-label="Previous month"
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                border: "1px solid var(--glass-border)",
                background: "var(--icon-btn-bg)",
                color: "var(--text-primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <ChevronLeft size={15} strokeWidth={2.5} />
            </button>
            <span
              style={{
                fontSize: "1rem",
                fontWeight: 700,
                color: "var(--text-primary)",
                minWidth: 140,
                textAlign: "center",
              }}
            >
              {extractMonthWithName(selectedDate)}
            </span>
            <button
              onClick={incrementDate}
              aria-label="Next month"
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                border: "1px solid var(--glass-border)",
                background: "var(--icon-btn-bg)",
                color: "var(--text-primary)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <ChevronRight size={15} strokeWidth={2.5} />
            </button>
          </div>
          <button
            onClick={() => setReportModal(true)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              padding: "7px 14px",
              borderRadius: 9,
              background: "rgba(16,185,129,0.1)",
              border: "1px solid rgba(16,185,129,0.2)",
              color: "#10b981",
              fontSize: "0.8125rem",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            <Download size={14} strokeWidth={2} /> Download Report
          </button>
        </div>

        {/* Stat cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(100px, 1fr))",
            gap: 1,
            background: "var(--glass-border)",
          }}
        >
          {attendanceItems.map((stat, i) => {
            const cfg = STAT_CONFIG[stat.label] || {
              color: "#64748b",
              bg: "rgba(100,116,139,0.1)",
              Icon: Clock,
            };
            const { Icon } = cfg;
            return (
              <div
                key={i}
                style={{
                  background: "var(--glass-bg)",
                  padding: "12px 8px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 5,
                }}
              >
                <span
                  style={{
                    fontSize: "0.5625rem",
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: "0.07em",
                    color: "var(--text-muted)",
                    textAlign: "center",
                  }}
                >
                  {stat.label}
                </span>
                <div
                  style={{
                    width: 38,
                    height: 38,
                    borderRadius: 10,
                    background: cfg.bg,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span style={{ fontSize: "1rem", fontWeight: 800, color: cfg.color }}>
                    <CountUp end={stat.value ?? 0} duration={1} />
                  </span>
                </div>
                <Icon size={11} strokeWidth={2} style={{ color: cfg.color, opacity: 0.7 }} />
              </div>
            );
          })}
        </div>
      </div>

      {/* ── Attendance cards ── */}
      <div className="animate-slide-up" style={{ animationDelay: "60ms" }}>
        <CustomPagination
          pageSize={pageSize ?? All}
          totalRecords={
            countData?.totalRecordsCount ??
            countData?.totalCount ??
            countData?.totalRecords ??
            attendancedata?.[0]?.attendanceData?.length ??
            attendancedata?.length ??
            0
          }
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onNextPage={handleNextPage}
          defaultPageSize={All}
          onPreviousPage={handlePreviousPage}
          onPageSizeChange={handlePageSizeChange}
          searchQuery={searchQuery}
          onSearchChange={(v) => {
            if (v !== undefined) setSearchQuery(v);
          }}
        >
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
              gap: 12,
              marginTop: 12,
            }}
          >
            {attendancedata?.length > 0 ? (
              attendancedata.map((data) => {
                const firstAttendanceData = data?.attendanceData;
                if (firstAttendanceData?.length > 0) {
                  return firstAttendanceData.map((staff) => {
                    const {
                      id,
                      date,
                      total_working_hours,
                      attendance_status,
                      in_time,
                      out_time,
                      attendance_note,
                    } = staff;
                    let statusLabel;
                    if (staff?.actual_attendance_status === attendanceLabel.WeekOff)
                      weekOffStatus = true;
                    if (staff?.actual_attendance_status === attendanceLabel.Holiday)
                      holidayOffStatus = true;
                    compOffHistory = staff?.compOffLeaveHistory?.date;
                    if (staff.attendance_status === WEEK_OFF) statusLabel = weekOff;
                    else if (staff.attendance_status === HOLIDAY_OFF) statusLabel = holiday;
                    else statusLabel = paidLeave;

                    const filteredStatusLabels = statusLabel?.filter((label) => {
                      if (label.status === attendanceLabel.OvertimeStatus) {
                        if (staff?.is_comp_off) return false;

                        const isApp =
                          staff?.staff?.staffGeneralInformation?.is_applicable_for_overtime ===
                            true ||
                          staff?.staff?.staffGeneralInformation?.is_applicable_for_overtime ===
                            "true" ||
                          profileData?.staffGeneralInformation?.is_applicable_for_overtime ===
                            true ||
                          profileData?.staffGeneralInformation?.is_applicable_for_overtime ===
                            "true" ||
                          data?.is_applicable_for_overtime === true ||
                          data?.is_applicable_for_overtime === "true" ||
                          data?.staffGeneralInformation?.is_applicable_for_overtime === true ||
                          data?.staffGeneralInformation?.is_applicable_for_overtime === "true";

                        if (!isApp) return false;
                      }
                      return true;
                    });

                    const handleStatusClick = (status) => {
                      const isSpecial =
                        staff.attendance_status === WEEK_OFF ||
                        staff.attendance_status === HOLIDAY_OFF ||
                        staff.isHoliday ||
                        staff.isWeekOff;
                      const isMarkable =
                        status === attendanceLabel.PresentStatus ||
                        status === attendanceLabel.AbsentStatus ||
                        status === attendanceLabel.HalfDayStatus ||
                        status === attendanceLabel.PaidLeaveStatus;
                      if ((isSpecial && isMarkable) || !isSpecial) openModal(status, staff);
                    };

                    return (
                      <StaffCard
                        key={id}
                        title={dateMonthName(date)}
                        staffAttendanceId={staff.staff_attendance_id}
                        RevertApi={RevertStatusToHoliday}
                        RevertCompOff={RevertStatusToWeekOff}
                        subtitle={getFormatDayName(date)}
                        shiftName={
                          staff?.staff?.staffGeneralInformation?.shift?.shift_name ||
                          data?.shift_name ||
                          data?.shift?.shift_name ||
                          profileData?.staffGeneralInformation?.shift?.shift_name ||
                          attendancedata?.[0]?.shift_name ||
                          attendancedata?.[0]?.shift?.shift_name
                        }
                        isHoliday={staff.is_holiday}
                        isWeekOff={staff?.is_week_off}
                        workingHours={total_working_hours && `${total_working_hours}`}
                        overtimeRequestedMinutes={staff?.overtime_requested_minutes}
                        historyEntries={{
                          status: attendance_status,
                          inTime: in_time,
                          outTime: out_time,
                        }}
                        status={attendance_status}
                        note={attendance_note}
                        onEditNote={() =>
                          handleNoteModal(staff.staff_attendance_id, attendance_note)
                        }
                        onViewLogs={() => handleViewLogs(staff)}
                        onStatusClick={handleStatusClick}
                        statusLabels={filteredStatusLabels}
                        weekOffStatus={weekOffStatus}
                        holidayOffStatus={holidayOffStatus}
                        compOffHistory={compOffHistory}
                        isCompOff={staff?.is_comp_off}
                        actualStatus={staff?.actual_attendance_status}
                        leaveType={staff?.leave_type}
                        overtimeRequests={staff?.overtimeRequests}
                        isOvertimeEligible={isOvertimeEligible(staff, data)}
                      />
                    );
                  });
                }
                return (
                  <div
                    key={data.id}
                    style={{
                      gridColumn: "1 / -1",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      padding: "40px 20px",
                      gap: 10,
                      background: "var(--glass-bg)",
                      border: "1px solid var(--glass-border)",
                      borderRadius: 14,
                    }}
                  >
                    <AlertCircle size={32} style={{ color: "var(--text-muted)", opacity: 0.4 }} />
                    <p style={{ color: "var(--text-muted)", margin: 0 }}>{notFound.dataNotFound}</p>
                  </div>
                );
              })
            ) : (
              <div
                style={{
                  gridColumn: "1 / -1",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  padding: "60px 20px",
                  gap: 12,
                  background: "var(--glass-bg)",
                  border: "1px solid var(--glass-border)",
                  borderRadius: 16,
                }}
              >
                <AlertCircle size={40} style={{ color: "var(--text-muted)", opacity: 0.4 }} />
                <p style={{ color: "var(--text-muted)", margin: 0 }}>{notFound.dataNotFound}</p>
              </div>
            )}
          </div>
        </CustomPagination>
      </div>

      {/* ── Attendance modal ── */}
      {modalType && (
        <BaseModal
          isOpen={Boolean(modalType)}
          toggler={closeModal}
          hideSubmit={
            modalType === attendanceLabel.overtimeModal &&
            (staffDetail?.overtime_requested_minutes != null ||
              staffDetail?.overtimeRequests?.length > 0)
          }
          submit={() => {
            if (modalType === attendanceLabel.presentModal) formikPresent.handleSubmit();
            if (modalType === attendanceLabel.halfDayModal) handleHalfDaySubmit();
            if (modalType === attendanceLabel.paidLeaveModal) formikPaidLeave.handleSubmit();
            if (modalType === attendanceLabel.compOffModal) formikCompOff.handleSubmit();
            if (modalType === attendanceLabel.absentModal) formikAbsent.handleSubmit();
            if (modalType === attendanceLabel.overtimeModal) formikOvertime.handleSubmit();
            if (modalType === attendanceLabel.LessHourStatus) formikLessHour.handleSubmit();
          }}
          title={
            <>
              <div className="fs-5">
                {modalType === attendanceLabel.paidLeaveModal
                  ? attendanceLabel.LeaveStatus
                  : modalType}
              </div>
              <div className="fs-8 text-secondary">{`${countData?.transformedResponse?.[0]?.name} | ${extractDateAsM(staffDetail?.date)}`}</div>
            </>
          }
          loader={btnLoader}
          disabled={btnLoader}
          submitText={modalType === attendanceLabel.halfDayModal ? attendanceLabel.Save : Submit}
        >
          {renderModalContent()}
        </BaseModal>
      )}

      {/* ── Half-day second modal ── */}
      <BaseModal
        isOpen={isSecondModalOpen}
        toggler={() => setSecondModalOpen(false)}
        title={
          <>
            <div className="fs-5">{modalType}</div>
            <div className="fs-8 text-secondary">{`${countData?.transformedResponse?.[0]?.name} | ${extractDateAsM(staffDetail?.date)}`}</div>
          </>
        }
        submitText={Submit}
        loader={btnLoader}
        submit={() => formikHalfDay.handleSubmit()}
      >
        {leaveData?.length > 0 ? (
          <BaseRadioGroup
            name="leaveOption"
            options={leaveData}
            selectedValue={formikHalfDay.values.leaveOption}
            onChange={(e) => formikHalfDay.setFieldValue(nameLabel.leaveOption, e.target.value)}
            value={formikHalfDay.values.leaveOption}
            touched={formikHalfDay.touched.leaveOption}
            error={formikHalfDay.errors.leaveOption}
            handleBlur={formikHalfDay.handleBlur}
          />
        ) : (
          <p style={{ textAlign: "center", color: "var(--text-muted)", padding: "20px 0" }}>
            {attendanceLabel.noLeaveAvailable}
          </p>
        )}
      </BaseModal>

      {/* ── Note modal ── */}
      <BaseModal
        isOpen={noteModal}
        toggler={() => setNoteModal(false)}
        title={formikNote.values.note !== "" ? attendanceLabel.editNote : attendanceLabel.AddNote}
        submitText={formikNote.values.note !== "" ? Update : Submit}
        submit={formikNote.handleSubmit}
        loader={btnLoader}
        disabled={btnLoader}
      >
        <BaseInput
          label={attendanceLabel.note}
          name={nameLabel.note}
          type="textarea"
          handleChange={formikNote.handleChange}
          placeholder={PlaceHolderFormat(attendanceLabel.note)}
          value={formikNote.values.note}
          touched={formikNote.touched.note}
          error={formikNote.errors.note}
          handleBlur={formikNote.handleBlur}
          required
        />
      </BaseModal>

      {/* ── Logs modal ── */}
      <BaseModal
        isOpen={logModal}
        toggler={() => setLogModal(false)}
        title={attendanceLabel.ViewLogs}
        submitText={Submit}
        hasSubmitButton={false}
      >
        <div className="d-flex flex-column gap-2 py-1">
          {logs?.length === 0 ? (
            <p className="text-center text-muted py-3 mb-0">{attendanceLabel.noLogsFound}</p>
          ) : (
            logs.map((log) => (
              <div key={log.id} className="d-flex gap-2 p-3 bg-light rounded border">
                <div className="pt-1 flex-shrink-0">
                  <RiCheckboxBlankCircleFill size={10} className="text-primary" />
                </div>
                <div className="flex-grow-1">
                  <p className="mb-0 small fw-medium">
                    {(log?.in_time || log?.out_time) && log?.attendance_via !== null ? (
                      log?.out_time ? (
                        `Punched out via ${log?.attendance_via}`
                      ) : (
                        `Punched in via ${log?.attendance_via}`
                      )
                    ) : (
                      <>
                        {attendanceLabel.MarkedAs} <strong>{log?.attendance_status}</strong>
                      </>
                    )}
                  </p>
                  <p className="mt-1 mb-0 text-muted small">
                    {log?.out_time
                      ? log?.attendance_via
                        ? `By ${log?.addedBy?.name || "System"} on ${extractDayMonth(log?.date)}, ${log?.out_time}${log?.location ? ` · ${log?.location}` : ""}`
                        : `By ${log?.addedBy?.name || "System"} on ${extractDayMonth(log?.date)}, ${log?.in_time} → ${log?.out_time}${log?.location ? ` · ${log?.location}` : ""}`
                      : log?.in_time
                        ? `By ${log?.addedBy?.name || "System"} on ${extractDayMonth(log?.date)}, ${log?.in_time}${log?.location ? ` · ${log?.location}` : ""}`
                        : `By ${log?.addedBy?.name || "System"} on ${extractDayMonth(log?.date)}`}
                  </p>
                  {log?.remarks && (
                    <p className="mt-1 mb-0 text-muted small">
                      <span className="fw-medium">Remarks:</span>{" "}
                      {log?.remarks?.length > 50 ? (
                        <>
                          <span id={`remarks-${log.id}`} className="cursor-pointer">
                            {`${log?.remarks?.substring(0, 50)}...`}
                          </span>
                          <Popovers
                            isOpen={popoverOpen === log.id}
                            target={`remarks-${log.id}`}
                            toggle={() => togglePopover(log.id)}
                            placement="top"
                            trigger="hover"
                          >
                            {log?.remarks}
                          </Popovers>
                        </>
                      ) : (
                        log?.remarks
                      )}
                    </p>
                  )}
                  {(log?.in_time || log?.out_time) &&
                    log?.attendance_via !== null &&
                    log?.staff_image && (
                      <img
                        src={`${BaseAttendanceURL}${log?.staff_image}`}
                        alt="staff"
                        className="mt-2 rounded object-fit-cover"
                        width="64"
                        height="64"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = onErrorImage;
                        }}
                      />
                    )}
                </div>
              </div>
            ))
          )}
        </div>
      </BaseModal>

      {/* ── Report modal ── */}
      <BaseModal
        isOpen={reportModal}
        toggler={() => {
          setReportModal(false);
          formik.resetForm();
        }}
        title={attendanceLabel.StaffAttendanceReport}
        submitText={Submit}
        submit={formik.handleSubmit}
        loader={btnLoader}
        disabled={btnLoader}
      >
        <form
          onSubmit={formik.handleSubmit}
          style={{ display: "flex", flexDirection: "column", gap: 12 }}
        >
          <BaseDatePicker
            name="startDate"
            label={attendanceLabel.StartDate}
            value={formik.values.startDate}
            onChange={(v) => formik.setFieldValue("startDate", v)}
            onBlur={formik.handleBlur}
            touched={formik.touched.startDate}
            error={formik.errors.startDate}
            placeholder={PlaceHolderFormat(attendanceLabel.StartDate)}
            required
          />
          <BaseDatePicker
            name="endDate"
            label={attendanceLabel.EndDate}
            value={formik.values.endDate}
            onChange={(v) => formik.setFieldValue("endDate", v)}
            onBlur={formik.handleBlur}
            touched={formik.touched.endDate}
            error={formik.errors.endDate}
            placeholder={PlaceHolderFormat(attendanceLabel.EndDate)}
            maxDate={new window.Date()}
            required
          />
        </form>
      </BaseModal>
    </div>
  );
};

export default AttendanceDetails;
